import { render, staticRenderFns } from "./need-list.vue?vue&type=template&id=590d708e&scoped=true"
import script from "./need-list.vue?vue&type=script&lang=js"
export * from "./need-list.vue?vue&type=script&lang=js"
import style0 from "./need-list.vue?vue&type=style&index=0&id=590d708e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d708e",
  null
  
)

export default component.exports